import React from "react";
import { useNavigate } from "react-router-dom";
import { Container } from "@mui/material";
import AuthPanel from "../components/AuthPanel";

export default function Login({ mode = "login" }: { mode?: "login" | "register" }) {
  const navigate = useNavigate();
  return (
    <Container maxWidth="xs" sx={{ py: { xs: 6, sm: 10 } }}>
      <AuthPanel initialMode={mode} onSuccess={() => navigate("/dashboard")} />
    </Container>
  );
}
